<template>
  <div id="layout">
    <header-view></header-view>
    <div class="main">
        <router-view />
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
import headerView from './header'
import footerView from './footer'
export default {
  data () {
    return {
      isBaidu: false,
    };
  },
  components: {headerView , footerView},
  mounted () {
    var u = navigator.userAgent;
    this.isBaidu = u.indexOf('baiduboxapp') > -1 ; //百度小程序环境
  },
  computed: {},
  methods: {}
}
</script>

<style lang='scss' scoped>
#layout{
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 7.5rem;
  margin: 0 auto;
}
.main{
  position: relative;
  padding-top: calc(2.07rem + 7px);
  width: 100%;
  min-height: 7rem;
  box-sizing: border-box;
  display: flex;
}
</style>